// FETCH ALL YARN_PROJECTION
export const FETCH_YARN_PROJECTION_REQUEST = 'FETCH_YARN_PROJECTION_REQUEST';
export const FETCH_YARN_PROJECTION_SUCCESS = 'FETCH_YARN_PROJECTION_SUCCESS';
export const FETCH_YARN_PROJECTION_FAILURE = 'FETCH_YARN_PROJECTION_FAILURE';

export const FETCH_YARN_PROJECTION_REPORTS_REQUEST = 'FETCH_YARN_PROJECTION_REPORTS_REQUEST';
export const FETCH_YARN_PROJECTION_REPORTS_SUCCESS = 'FETCH_YARN_PROJECTION_REPORTS_SUCCESS';
export const FETCH_YARN_PROJECTION_REPORTS_FAILURE = 'FETCH_YARN_PROJECTION_REPORTS_FAILURE';


// FETCH ALL YARN_PROJECTION
export const FETCH_YARN_PROJECTION_TYPE_DISTINCT_REQUEST = 'FETCH_YARN_PROJECTION_TYPE_DISTINCT_REQUEST';
export const FETCH_YARN_PROJECTION_TYPE_DISTINCT_SUCCESS = 'FETCH_YARN_PROJECTION_TYPE_DISTINCT_SUCCESS';
export const FETCH_YARN_PROJECTION_TYPE_DISTINCT_FAILURE = 'FETCH_YARN_PROJECTION_TYPE_DISTINCT_FAILURE';

// CREATE YARN_PROJECTION
export const CREATE_YARN_PROJECTION_REQUEST = 'CREATE_YARN_PROJECTION_REQUEST';
export const CREATE_YARN_PROJECTION_SUCCESS = 'CREATE_YARN_PROJECTION_SUCCESS';
export const CREATE_YARN_PROJECTION_FAILURE = 'CREATE_YARN_PROJECTION_FAILURE';

// FETCH SINGLE PART DATA
export const FETCH_SINGLE_YARN_PROJECTION_REQUEST = 'FETCH_SINGLE_YARN_PROJECTION_REQUEST';
export const FETCH_SINGLE_YARN_PROJECTION_SUCCESS = 'FETCH_SINGLE_YARN_PROJECTION_SUCCESS';
export const FETCH_SINGLE_YARN_PROJECTION_FAILURE = 'FETCH_SINGLE_YARN_PROJECTION_FAILURE';

// UPDATE YARN_PROJECTION
export const UPDATE_YARN_PROJECTION_REQUEST = 'UPDATE_YARN_PROJECTION_REQUEST';
export const UPDATE_YARN_PROJECTION_SUCCESS = 'UPDATE_YARN_PROJECTION_SUCCESS';
export const UPDATE_YARN_PROJECTION_FAILURE = 'UPDATE_YARN_PROJECTION_FAILURE';

// DELETE YARN_PROJECTION
export const DELETE_YARN_PROJECTION_REQUEST = 'DELETE_YARN_PROJECTION_REQUEST';
export const DELETE_YARN_PROJECTION_SUCCESS = 'DELETE_YARN_PROJECTION_SUCCESS';
export const DELETE_YARN_PROJECTION_FAILURE = 'DELETE_YARN_PROJECTION_FAILURE';

export const RESET_YARN_PROJECTION_INFO = 'RESET_YARN_PROJECTION_INFO';

export const CREATE_YARN_PROJECTION_FORM = 'CREATE_YARN_PROJECTION_FORM';

export const UPDATE_YARN_PROJECTION_FORM = 'UPDATE_YARN_PROJECTION_FORM';

export const FETCH_PRNO_REQUEST = 'FETCH_PRNO_REQUEST';
export const FETCH_PRNO_SUCCESS = 'FETCH_PRNO_SUCCESS';
export const FETCH_PRNO_FAILURE = 'FETCH_PRNO_FAILURE';

export const FETCH_COMBINED_SL_NO_SUCCESS = 'FETCH_COMBINED_SL_NO_SUCCESS';
export const FETCH_COMBINED_SL_NO_FAILURE = 'FETCH_COMBINED_SL_NO_FAILURE';
export const FETCH_COMBINED_SL_NO_REQUEST = 'FETCH_COMBINED_SL_NO_REQUEST';

export const RESET_COMBINED_SL_NO = 'RESET_COMBINED_SL_NO';

export const FETCH_YARN_PROJECTION_REPORTS_OVERALL_REQUEST = 'FETCH_YARN_PROJECTION_REPORTS_OVERALL_REQUEST';
export const FETCH_YARN_PROJECTION_REPORTS_OVERALL_SUCCESS = 'FETCH_YARN_PROJECTION_REPORTS_OVERALL_SUCCESS';
export const FETCH_YARN_PROJECTION_REPORTS_OVERALL_FAILURE = 'FETCH_YARN_PROJECTION_REPORTS_OVERALL_FAILURE';


export const FETCH_YARN_PROJECTION_OUTSTANDING_REQUEST = 'FETCH_YARN_PROJECTION_OUTSTANDING_REQUEST';
export const FETCH_YARN_PROJECTION_OUTSTANDING_SUCCESS = 'FETCH_YARN_PROJECTION_OUTSTANDING_SUCCESS';
export const FETCH_YARN_PROJECTION_OUTSTANDING_FAILURE = 'FETCH_YARN_PROJECTION_OUTSTANDING_FAILURE';



// export const UPDATE_FLD_SUBJECT = 'UPDATE_FLD_SUBJECT'; // subject validations 0407